import React, { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearRefundSearchFilter,
  selectRefundState,
  setRefundSearchFilter,
  setRefundStatusFilter,
} from "../../../store/refund/refundFilterSlice";

import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";

import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import classes from "./refundFilterPage.module.css";

// IMPORTANT: IDs must be strings (URL params are strings)
const refundStatusOptions = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Pending" },
  { id: "1", label: "Approved" },
  { id: "2", label: "Rejected" },
];

export const RefundFilterPage = ({ filters }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { status, search } = useSelector(selectRefundState);

  const dispatch = useDispatch();

  useEffect(() => {
    const statusParam = searchParams.get("status") ?? "";
    const searchParam = searchParams.get("search") ?? "";

    dispatch(setRefundStatusFilter(statusParam));
    dispatch(setRefundSearchFilter(searchParam));
  }, [searchParams, dispatch]);

  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "status") dispatch(setRefundStatusFilter(value));
      if (key === "search")
        dispatch(
          value ? setRefundSearchFilter(value) : clearRefundSearchFilter()
        );
    },
    [dispatch, searchParams, setSearchParams]
  );

  return (
    <div className={classes.box}>
      {/* Search input */}
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      {/* Status dropdown */}
      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={refundStatusOptions}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>
    </div>
  );
};
